import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const cmdApi = axios.create({
  baseURL: `${BASE}/api/cmd`,
  withCredentials: true, // send/receive the cmd_access_token cookie
  headers: { "Content-Type": "application/json" },
});

// Attach the Bearer token when we have one in localStorage (fallback for curl parity + mobile Safari).
cmdApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("cmd_access_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function saveToken(t) {
  if (t) localStorage.setItem("cmd_access_token", t);
}
export function clearToken() {
  localStorage.removeItem("cmd_access_token");
}
